export const NOTIFICATIONS_TYPES = {
    'liked': 1,
    'shared': 2,
    'purchased': 3,
    'advertisementEnded': 4
};

